import { REST_API_SERVER } from '../util/constants'


/////////////////////////////////////////////////////////////////////////
// return browser public IP, for localhost testing return heroku IP
//    "ip": "69.181.219.69",
//    "city": "Saratoga",
//    "region_code": "CA",
//    "country": "US",
//    "latitude": 37.2539,
//    "longitude": -122.0638,
//    "org": "Comcast Cable Communications, LLC"
export function GetIP() {
    var url = "https://ipapi.co/json/";
    //var url = "http://www.geoplugin.net/json.gp";  // for non-https, use nothing in HEADER!

    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        //url = heroku_url + url;
    }

    var result = GetCORSURL(url)
       .then(response => {
            var ip_obj = new Object();
            var ip_raw = response;
           if(response.status >= 400){
                throw new Error("bad response from server")
            }

            console.log("GetIP: ip_raw=", ip_raw);
            ip_obj.ip = ip_raw.ip
            ip_obj.city = ip_raw.city
            ip_obj.region_code = ip_raw.region_code
            ip_obj.country = ip_raw.country
            ip_obj.latitude = ip_raw.latitude
            ip_obj.longitude = ip_raw.longitude
            ip_obj.org = ip_raw.org
            return ip_obj;
       })
       .then(data => {
           //console.log("GetCORSURL.read1= ", data);
           return data;
       })
    return(result);  // async result later, returns promise

}



export async function GetCORSURL(url) {
    var result=fetch(url, {
        crossDomain: true,
        method: 'GET',
        mode: 'cors',
        })
       .then(response => {
           if(response.status >= 400){
                throw new Error("bad response from server")
           }
           console.log("GetCORSURL.202: response=", response);
           return response.json();
       })
       .then(data => {
           console.log("GetCORSURL.206:  data= ", data);
           return data;
       })
    return(result);  // async result later, returns promise
}

// TIP: Some CORS issues are due to non https://
export async function GetCORSRaw(url) {
    var result= await fetch(url, {
            crossDomain: true,
            method: 'GET',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                'Content-Type': 'application/json, * /*'
            }
        })
       .then(response => {
           if(response.status >= 400){
                throw new Error("bad response from server")
           }
           console.log("GetCORSRaw.222: response.json=", response);
           return response.text();
       })
       .then(data => {
           console.log("GetCORSRaw.233:  data= ", data);
           return data;
       })
       return(result);  // async result later, returns promise
}


export function GetURL(url) {
    var result=fetch(url, {
        /*
            mode: 'cors',
        })
        */
            method: 'GET',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                'Content-Type': 'application/json, * /*'
            }
        })
       .then(response => {
           if(response.status >= 400){
                throw new Error("bad response from server")
            }
           return response.json();
       })
       .then(data => {
           //console.log("user.read1= ", data);
           return data;
       })
    return(result);  // async result later, returns promise
}





/*
 * get speech data
 */
export function GetAudioData(speaker_id, text) {
   var result=fetch(REST_API_SERVER+
                    "/synthesize_text/?lan_code=en&speaker_id="+speaker_id+
                    "&text="+text,  {
          method: "GET",
          headers: {
              "accept": "application/json",
              "x-requested-with": "xmlhttprequest",
              "Access-Control-Allow-Origin": "*"
              //"Authorization": `JWT `+ localStorage.getItem('jwt_token')
           }  
        })
        .then(response => {
           if(response.status >= 400){
                //throw new Error("bad response from server")
           }
           //console.log("***** read_all_ep="+JSON.stringify(response.json()));
           return response.json();
        })
        .then(data => {
           return data;
        });
    return result;
};



